<template>
  <div class="main-content sn-content">

    <el-card class="box-card">
      <div>
        <div class="vertical">
          <i class="el-icon-circle-check main-color"></i>
          <span class="secure-title">联系我们</span>
        </div>
        <div style="display:flex;margin-top:26px">
          <div style="display:flex;flex-direction: column;align-items:center;margin-right:15px">
            <img style="width:96px;" src="https://home-oss.pingxingyun.com/homePage/ic_wechat_paraverse.jpg" alt="">
            <p style="margin-top:20px;">公众号</p>
          </div>
          <div style="display:flex;flex-direction: column;align-items:center">
            <img style="width:96px;" src="https://home-oss.pingxingyun.com/homePage/ewm__paraverse.png" alt="">
            <p style="margin-top:20px;">在线咨询</p>
          </div>
        </div>
        <p class="tag" style="">技术支持、系统故障、咨询服务、投诉建议，请您通过扫描微信二维码添加微信在线咨询或者拨打售后咨询热线 4006781024（工作日 9:00 - 19:00） 向平行云工程师寻求支持。</p>

      </div>
      <el-divider></el-divider>
      <div>
        <div class="vertical">
          <i class="el-icon-circle-check main-color"></i>
          <span class="secure-title">帮助</span>
        </div>
        <p class="tag" style="">系统计费、使用错误等问题，请发邮件：包含问题描述、报错截图、联系人电话至邮箱business@paraverse.cc，我们会在1个工作日内处理。</p>
      </div>
    </el-card>

  </div>
</template>

<script>
  import {Message} from "element-ui";

  export default {
    data() {
      return {}
    },
    created() {

    },
    computed: {
      user() {
        return this.$store.state.user;
      },
    },
    methods: {
    },
    mounted: function () {

    },
    beforeDestroy() {

    }
  }
</script>

